module.exports = __webpack_public_path__ + "img/IMG_4215_L_BlackMatted_MockedUp.739d2ae9.jpg";